import React, { useState } from 'react';

import './Modal.css'

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-perizie">
      <div className="modal-perizie-content">
        <span className="btn btn-primary m-1" onClick={onClose}>
        {'<'} torna alle denunce
        </span>
        {children}
      </div>
    </div>
  );
};

export default Modal;
